import React, { useState, useEffect } from "react";
import { EditIcon, Trash, TrashWhite } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import Pagination from "../section/Pagination";
import axios from "axios";
import CustomAlert from "../CustomAlert";

export default function AllAccessories() {
  const [accessories, setAccessories] = useState([]);
  const [selectedAccessories, setSelectedAccessories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alertMsg, setAlertMsg] = useState({ type: "", message: "" });
  // Dialog states
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteAccessoryId, setDeleteAccessoryId] = useState(null);
  const [showBulkDeleteDialog, setShowBulkDeleteDialog] = useState(false);

  const API_BASE_URL = "https://laravel-api.aj-mart.com/api";
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  useEffect(() => {
    fetchAccessories();
  }, []);

  const fetchAccessories = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/accessories`);
      // معالجة حقل الألوان: محاولة التحويل من JSON، وإذا فشل نقسم باستخدام split
      const processed = response.data.accessories.map((item) => {
        let colorsArr = [];
        if (item.accessories_color) {
          try {
            colorsArr = JSON.parse(item.accessories_color);
          } catch (error) {
            colorsArr = item.accessories_color.split(",");
          }
        }
        return { ...item, accessories_color: colorsArr };
      });
      setAccessories(processed);
    } catch (error) {
      setAlertMsg({ type: "error", message: "Failed to fetch accessories" });
      console.error("Error fetching accessories:", error);
    } finally {
      setLoading(false);
    }
  };

  // عند النقر على زر الحذف الفردي
  const handleDeleteClick = (accessoryId) => {
    setDeleteAccessoryId(accessoryId);
    setShowDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_BASE_URL}/accessories/delete/${deleteAccessoryId}`);
      setAlertMsg({ type: "success", message: "Accessory deleted successfully" });
      setAccessories((prev) =>
        prev.filter((item) => item.accessories_id !== deleteAccessoryId)
      );
      setSelectedAccessories((prev) =>
        prev.filter((id) => id !== deleteAccessoryId)
      );
    } catch (error) {
      setAlertMsg({ type: "error", message: "Failed to delete accessory" });
      console.error("Error deleting accessory:", error);
    } finally {
      setShowDeleteDialog(false);
      setDeleteAccessoryId(null);
    }
  };

  // عند النقر على زر الحذف الجماعي
  const handleBulkDeleteClick = () => {
    if (!selectedAccessories.length) {
      setAlertMsg({ type: "error", message: "Please select accessories to delete" });
      return;
    }
    setShowBulkDeleteDialog(true);
  };

  const confirmBulkDelete = async () => {
    try {
      await Promise.all(
        selectedAccessories.map((id) =>
          axios.delete(`${API_BASE_URL}/accessories/delete/${id}`)
        )
      );
      setAlertMsg({ type: "success", message: "Selected accessories deleted successfully" });
      setAccessories((prev) =>
        prev.filter((item) => !selectedAccessories.includes(item.accessories_id))
      );
      setSelectedAccessories([]);
    } catch (error) {
      setAlertMsg({ type: "error", message: "Failed to delete selected accessories" });
      console.error("Error deleting accessories:", error);
    } finally {
      setShowBulkDeleteDialog(false);
    }
  };

  const handleSelectAccessory = (accessoryId) => {
    setSelectedAccessories((prev) =>
      prev.includes(accessoryId)
        ? prev.filter((id) => id !== accessoryId)
        : [...prev, accessoryId]
    );
  };

  const handleSelectAll = (e) => {
    setSelectedAccessories(e.target.checked ? accessories.map((item) => item.accessories_id) : []);
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  if (loading) return <div className="py-[25px]">Loading accessories...</div>;

  return (
    <section className="py-[25px]">
      <div className="main-title mb-[20px]">All Accessories</div>
      {alertMsg.message && (
        <CustomAlert
          type={alertMsg.type}
          message={alertMsg.message}
          onClose={() => setAlertMsg({ type: "", message: "" })}
        />
      )}
      <div className="flex justify-end items-center gap-[10px] mb-[20px]">
        <button
          className={`btn bg-red-500 hover:bg-red-600 flex items-center gap-2 ${
            !selectedAccessories.length ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleBulkDeleteClick}
          disabled={!selectedAccessories.length}
        >
          <TrashWhite />
          <span>Delete Accessories ({selectedAccessories.length})</span>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-200 text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-200 p-[10px]">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedAccessories.length === accessories.length}
                />
              </th>
              <th className="border border-gray-200 p-[10px]">IMG</th>
              <th className="border border-gray-200 p-[10px]">Accessory Name</th>
              <th className="border border-gray-200 p-[10px]">Category</th>
              <th className="border border-gray-200 p-[10px]">Brand</th>
              <th className="border border-gray-200 p-[10px]">ID</th>
              <th className="border border-gray-200 p-[10px]">Stocks</th>
              <th className="border border-gray-200 p-[10px]">Price</th>
              <th className="border border-gray-200 p-[10px]">Discount</th>
              <th className="border border-gray-200 p-[10px]">Colors</th>
              <th className="border border-gray-200 p-[10px]">Control</th>
            </tr>
          </thead>
          <tbody>
            {accessories.map((item) => (
              <tr key={item.accessories_id} className="bg-white hover:bg-gray-50">
                <td className="border border-gray-200 p-[10px]">
                  <input
                    type="checkbox"
                    checked={selectedAccessories.includes(item.accessories_id)}
                    onChange={() => handleSelectAccessory(item.accessories_id)}
                  />
                </td>
                <td className="border border-gray-200 p-[10px]">
                  <img
                    src={`https://laravel-api.aj-mart.com/storage/app/public/${item.accessories_main_img}`}
                    alt={item.accessories_name_E}
                    className="w-16 h-16 object-cover"
                  />
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {truncateText(item.accessories_name_E, 50)}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_category}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_brand_name}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_id}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_stock_available}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_price}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {item.accessories_price_discount || "-"}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {Array.isArray(item.accessories_color)
                    ? item.accessories_color.join(", ")
                    : item.accessories_color}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  <div className="flex items-center gap-3">
                    <Link to={`/editAccessories/${item.accessories_id}`} className="cursor-pointer">
                      <EditIcon />
                    </Link>
                    <div className="cursor-pointer" onClick={() => handleDeleteClick(item.accessories_id)}>
                      <Trash />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="py-[25px]">
        <Pagination />
      </div>

      {/* Dialog تأكيد الحذف الفردي */}
      {showDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-5 text-center">
            <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
            <p className="mb-4">Are you sure you want to delete this accessory?</p>
            <div className="flex justify-center gap-4">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={() => setShowDeleteDialog(false)}>
                Cancel
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={confirmDelete}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Dialog تأكيد الحذف الجماعي */}
      {showBulkDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-5 text-center">
            <h2 className="text-xl font-bold mb-4">Confirm Bulk Deletion</h2>
            <p className="mb-4">Are you sure you want to delete {selectedAccessories.length} accessories?</p>
            <div className="flex justify-center gap-4">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={() => setShowBulkDeleteDialog(false)}>
                Cancel
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={confirmBulkDelete}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
